var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.appId() !== 'onboarding')?_c('DesktopSideBar',{attrs:{"menuItems":_vm.menuItems}}):_vm._e(),(_vm.appId() !== 'onboarding')?_c('MobileSideBar',{attrs:{"menuItems":_vm.menuItems}}):_vm._e(),_c('SettingsMobileSideBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }